var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-award-card",on:{"click":_vm.openInApp}},[_c('img',{staticClass:"hb-img",attrs:{"src":_vm.cardItem.award_img,"alt":""}}),_c('p',{staticClass:"award-name"},[_vm._v(_vm._s(_vm.cardItem.award_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }